import React, {useState, useCallback, useEffect} from 'react';
import {Row, Col, Menu, Popover, Avatar, Icon, Layout, Select, Input, Affix} from 'antd';
import DocumentMeta from 'react-document-meta';
import intl from 'react-intl-universal';
import {bindActionCreators} from 'redux';
import {useSelector, useDispatch} from 'react-redux';
import {get} from 'lodash';
import {useHistory, useRouteMatch} from 'react-router';
import {languages} from '@/constants';
import MiniHeader from '@/components/MiniHeader/index';
import * as actions from '@/store/actions';
import './style.scss';
import {string} from '@/utils/string';

const {Footer, Sider, Content} = Layout;
const {Option} = Select;
const {Search} = Input;

function generateNavMenus() {
  return [{
    displayName: "书苑首页",
    link: '/',
    reg: /^/
  }, {
    displayName: '书库',
    link: '/classify',
    reg: /^/
  }, {
    displayName: '我的书架',
    link: '/readlog',
    reg: /^/
  }, {
    displayName: '作家专区',
    link: '/author',
    reg: /^/
  }];
}

const meta = {
  title: '蜜阅书苑_华语言情阅读品牌',
  description: '蜜阅书苑是国内新一线言情小说阅读网站，行业领先的泛言情IP孵化平台。提供总裁小说、现代言情、古代言情、悬疑灵异等热门小说免费阅读，最火最新的言情小说大全，尽在，尽在www.mixs.cn',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: '蜜阅书苑,蜜阅,言情小说,小说阅读网,阅读阁'
    }
  }
};

const MiniBasicLayout = (props) => {
  const {children, className,searchFocus} = props;
  const history = useHistory();
  const match = useRouteMatch();
  const [navMenus, setNavMenus] = useState([]);
  const menuSelectedKeys = [get(navMenus.find((menu) => menu.reg.test(match.path)), 'link')].filter(Boolean);
  const {userInfo, language} = useSelector((state) => ({
    userInfo: state.global.userInfo,
    language: state.global.language
  }));
  const onMenuClick = ({key}) => {
    history.push(key);
  }
  //监听语言变化
  useEffect(() => {
    setNavMenus(generateNavMenus());
  }, [language])
  const renderUserInfoPanel = useCallback(() => {
    const {changeSystemLanguage} = bindActionCreators(actions, useDispatch());
    const {username, email} = userInfo;
    return <div className="user-info-panel">
      <div className="basic-info">
        <div>
          <Avatar src={require('@/assets/avtar.jpeg')} size={38}/>
        </div>
        <div style={{paddingLeft: 16}}>
          <div>{username}</div>
          <div>{email}</div>
        </div>
      </div>
      <ul className="action-menu">
        <li>
          <Icon type="diff"/>
          <span> {intl.get('Action.ChangeLanguage')}</span>
          <Select value={language} placeholder="请选择" style={{width: 100, float: 'right'}} size="small"
                  onChange={changeSystemLanguage}>
            {
              languages.map((lang) => <Option key={lang.value} value={lang.value}>{lang.label}</Option>)
            }
          </Select>
        </li>
        <li><Icon type="logout"/><span> {intl.get('Action.Logout')}</span></li>
      </ul>
    </div>
  }, [userInfo, language])

  return (
    <DocumentMeta {...meta}>
      <Layout className="g-container">
        <div style={{'width': '100%'}}>
          <MiniHeader/>
        </div>
        <Content className="g-body bg-white">
          {children}
        </Content>
        <Footer className="g-footer bg-white">
          <div className="footer-con">
            <div className="inner-link"><a href="#" target="_blank">友情链接</a> | <a href="#" target="_blank">友情链接</a> | <a
              href="#" target="_blank">友情链接</a> | <a href="#" target="_blank">友情链接</a> | <a href="#"
                                                                                            target="_blank">友情链接</a> | <a
              href="#" target="_blank">友情链接</a> | <a href="#" target="_blank">友情链接</a> | <a href="#"
                                                                                            target="_blank">友情链接</a> | <a
              href="#" target="_blank">友情链接</a>
            </div>
            <Row align="middle">
              <Col span={18}>
            <div className="copyrights">Copyright © 2020 mixs.cn, All Rights Reserved. <a target="_blank"
                                                                                              href="#">蜜阅书苑</a>版权所有
              未经书面许可不得复制转载。
              <div> 浙公安机关备案33010602000912号 电信增值业务许可证：浙B2-20160439 <a href="http://www.beian.miit.gov.cn/"
                                                                     target="_blank">浙ICP备12033801号-4</a> <br/>请所有作者发布作品时务必遵守国家互联网信息管理办法规定，我们拒绝任何违规小说，一经发现，即作删除！<br/>办公地址：杭州市西湖区绿城西溪世纪中心2-619
                联系电话 0571-86025512</div>
            </div>
            <div className="safe-img-con">
              <a href="http://www.12377.cn" target="_blank">
                <div className="safe-img1"></div>
              </a>
              <a href="http://www.shjbzx.cn" target="_blank">
                <div className="safe-img2"></div>
              </a>
              <a
                href="https://ss.knet.cn/verifyseal.dll?sn=e17122933010071243aa8b000000&ct=df&a=1&pa=0.014416504272526387"
                target="_blank">
                <div className="safe-img3"></div>
              </a>

            </div>
              </Col>
              <Col span={6}>
              </Col>
            </Row>
          </div>
        </Footer>
      </Layout>
    </DocumentMeta>
  )
}

export default MiniBasicLayout;
